import { NextRouter } from "next/router"
import { Notification } from "@/types/notification"

import { handleNotificationAction } from "@/lib/storage/notifications-slice"
import { AppDispatch } from "@/lib/storage/redux-store"
import { toastManager } from "@/lib/toast"
import { NotificationDetailsLazy } from "@/components/notifications/notification-details-lazy"
import { NotificationToastLeading } from "@/components/notifications/notification-leading"

export function showToast(
  notification: Notification,
  {
    dispatch,
    router,
    showAction = true,
  }: {
    dispatch: AppDispatch
    router: NextRouter
    showAction?: boolean
  }
) {
  toastManager.add({
    data: {
      leading: <NotificationToastLeading value={notification} />,
    },
    description: <NotificationDetailsLazy value={notification} toast />,
    ...(showAction
      ? {
          actionProps: {
            children: "View",
            onClick: () => {
              void dispatch(
                handleNotificationAction({
                  notification,
                  router,
                  surface: "toast",
                })
              )
            },
          },
        }
      : {}),
  })
}
